/**
 * Shared frontend configuration.
 *
 * The API base URL was previously hardcoded as http://localhost:3001 in
 * several engines/components (and as a bare relative /api path in others,
 * which 404s because the CRA dev server has no proxy configured). Use this
 * one value everywhere; set REACT_APP_API_URL in the environment for any
 * non-local deployment.
 *
 * Production fix (2026-11-03): the fallback used to be localhost:3001
 * unconditionally, and the production bundle is built without
 * REACT_APP_API_URL - so in every visitor's browser, auth and every
 * other apiUrl call went to the visitor's own localhost:3001 and
 * failed with "Failed to fetch". Sign-in/registration never worked
 * on the live site. Now: an explicit REACT_APP_API_URL still wins;
 * a page served from localhost keeps the dev backend default; any
 * other origin uses same-origin relative paths (the host proxies
 * /api to the backend).
 */
const servedFromLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_URL: string =
    process.env.REACT_APP_API_URL || (servedFromLocalhost ? 'http://localhost:3001' : '');

export const apiUrl = (path: string): string =>
    `${API_URL}${path.startsWith('/') ? path : `/${path}`}`;
